export enum BlogType {
  DREVOL = "drevol",
  SHOP = "shop",
  EVOLUXE = "evoluxe",
}

export enum BlogStatus {
  DRAFT = "draft",
  PUBLISHED = "published",
}

export interface IBlog {
  id: string;
  title: string;
  slug: string;
  content: string;
  coverImageUrl: string | null;
  type: BlogType;
  status: BlogStatus;
  createdAt: string;
  updatedAt: string;
}

export interface IBlogCreateDto {
  title: string;
  slug: string;
  content: string;
  coverImageUrl?: string | null;
  type: BlogType;
  status: BlogStatus;
}
